import { useNavigate } from 'react-router-dom';
import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import postClockOutHost from 'Api/host-attendance-record/postClockOutHost';

import { useStatusState } from 'Store/status-state';
import { useToast } from 'Store/toast';
import postClockOutHostRequest from 'Domain/host-attendance-record/model/request/postClockOutHostRequest';
import { useHostAttendanceRecordState } from 'View/host-attendance-record/state';

const usePostClockOutHost = () => {
  const { t } = useTranslation('host-attendance');
  const navigate = useNavigate();
  const { onOpenStatusState } = useStatusState();
  const { onOpenToast } = useToast();
  const { updateState } = useHostAttendanceRecordState();

  return useMutation({
    mutationFn: async (formData) => {
      const payload = await postClockOutHostRequest(formData);

      const result = await postClockOutHost(payload);

      return result;
    },
    onSuccess: async (result) => {
      if (result?.violationTypes?.length > 0) {
        const violations = result.violationTypes;
        onOpenStatusState({
          type: 'warning',
          title: t('violation_detected.title'),
          description: t('violation_detected.description.clock_out'),
          violations,
        });
      } else {
        onOpenStatusState({
          type: 'success',
          title: t('success_clock_out.title'),
          description: t('success_clock_out.description'),
        });
      }

      navigate('/host');
    },
    onError: async (error) => {
      onOpenToast({
        description: error?.response?.data?.errors[0]?.message || t('loading_attendance.process_failed'),
        status: 'failed',
        duration: 5,
        position: 'top',
        type: 'mobile',
      });
    },
    onSettled: async () => {
      updateState({ isLoading: false });
    },
  });
};

export default usePostClockOutHost;
